<template>
  <div id="verify-match-step-right-part" class="row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 styled-scrollbar-custom pr-under-md-0 pl-under-md-0">
    <div id="verify-match-step-right-part-inside" class="w-100">
      <div class="col-12 pl-0 pr-0 mb-1">
        <b-form-group
          :label="$t('annonce.vehicle.need.image')"
          label-for="vehicleFiles-input"
          :invalid-feedback="imagesVehicleState.invalidFeedback"
          :state="imagesVehicleState.state"
          class="small-text">
          <b-form-file
            ref="vehicleFiles-input"
            id="vehicleFiles-input"
            :browse-text="$t('Select')"
            placeholder=""
            multiple
            @input="setVehicleFiles($event)"
            :drop-placeholder="$t('drop-placeholder')"
            required
            accept=".png, .jpeg, .jpg">
          </b-form-file>
        </b-form-group>
      </div>
      <PreviewSeveralImages fileId="recto" :files="vehicleFiles" @deleteFileInPreview="deleteFile"></PreviewSeveralImages>
    </div>
  </div>
</template>

<script>
import i18n from "../../i18n";
import PreviewSeveralImages from "../../components/b122/showFields/PreviewSeveralImages";
import api from "../../services/api"

export default {
  name: "VerifyMatchStep1",

  components: {
    PreviewSeveralImages,
  },

  props:{
    'vehicleFilesSaved': Array,
    'imageInvalidState': Boolean
  },

  emits:["updateSelectedPhotos"],

  data(){
    return {
      vehicleFiles : [],
      imagesVehicleState:{
        state: null,
        invalidFeedback: null,
        value: null
      },
      _blobUrls: []
    }
  },

  async mounted(){
    const files = (this.$props.vehicleFilesSaved || [])
    this.vehicleFiles = await Promise.all(files.map(async (file) => {
      if (file && file.id) {
        const blobUrl = await this.loadProtectedFile(file.fileUrl || file.url)
        return { ...file, url: blobUrl || null }
      } else {
        return { ...file }
      }
    }))
  },

  beforeDestroy() {
    this.cleanupBlobs()
  },

  watch:{
    'imageInvalidState': {
      immediate:true,
      handler () {
        if(this.$props.imageInvalidState === false){
          this.imagesVehicleState.state = false
          this.imagesVehicleState.invalidFeedback = this.$i18n.t('MandatoryField')
        }
      }
    }
  },


  methods:{
    pushBlobUrl(u) {
      if (!u) return u
      if (!this._blobUrls) this._blobUrls = []
      this._blobUrls.push(u)
      return u
    },

    cleanupBlobs() {
      if (this._blobUrls && this._blobUrls.length) {
        this._blobUrls.forEach(u => { try { window.URL.revokeObjectURL(u) } catch (e) {} })
      }
      this._blobUrls = []
    },

    isAlreadyResolvedUrl(u) {
      return typeof u === 'string' && (u.startsWith('blob:') || u.startsWith('data:') || u.startsWith('http://') || u.startsWith('https://'))
    },

    async loadProtectedFile(fileUrl) {
      if (!fileUrl) return null
      if (this.isAlreadyResolvedUrl(fileUrl)) return fileUrl
      try {
        const res = await api.get(fileUrl, { responseType: 'blob' })
        return this.pushBlobUrl(window.URL.createObjectURL(res.data))
      } catch (e) {
        return null
      }
    },

    setVehicleFiles(event){
      if(event){
        event.forEach(file => {
          const fileUrl = URL.createObjectURL(file)
          this.vehicleFiles.push({ url: fileUrl, file: file })
          this.imagesVehicleState.state = null
          this.imagesVehicleState.invalidFeedback = null
        })
      }
      this.$refs['vehicleFiles-input'].reset()
      this.$emit('updateSelectedPhotos', this.vehicleFiles)
    },

    deleteFile(index){
      const removed = this.vehicleFiles.splice(index,1)
      if (removed && removed[0] && removed[0].url && typeof removed[0].url === 'string' && removed[0].url.startsWith('blob:')) {
        try { window.URL.revokeObjectURL(removed[0].url) } catch (e) {}
        this._blobUrls = (this._blobUrls || []).filter(u => u !== removed[0].url)
      }

      this.imagesVehicleState.state = null
      this.imagesVehicleState.invalidFeedback = null

      this.$emit('updateSelectedPhotos', this.vehicleFiles)
    },

    // onFileInputChange() {
    //   const maxFilesAllowed = 3;
    //   const files = this.vehicleFiles;
    //   if (files && files.length > maxFilesAllowed) {
    //     this.vehicleFiles = files.slice(0, maxFilesAllowed);
    //   }
    // }

  },
}
</script>

<style scoped>
/* pour affichage desktop (md) : scroll pas sur la page entière mais sur le contenu modifiable uniquement */
@media (min-width: 769px) {
  #verify-match-step-right-part {
    height: 100%;
    overflow: auto;
  }
  #verify-match-step-right-part-inside {
    padding-left: 3px; /* pour voir le border sur les input focus */
    width: 100%;
    margin-bottom: auto; /* si il n'y a pas assez d'items pour remplir la hauteur */
  }
}

.custom-span-img{
  font-size: 14px;
  font-weight: 500;
  display: block;
  color: var(--main-grey-medium);
}

</style>



// WEBPACK FOOTER //
// src/views/match/VerifyMatchStep1.vue